import { CardProductCheckout } from "../../components/CardProductCheckout";
import {
  CardGray,
  CardPayment,
  CheckoutContainer,
  FormContainer,
  SummaryContainer,
} from "./style";
import CreditCard from "../../assets/credit-card.svg";
import Pix from "../../assets/pix.svg";
import Ticket from "../../assets/ticket.svg";
import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import { InputData } from "../../components/InputData";
import { SelectData } from "../../components/SelectData";
import { InputPayment } from "../../components/InputPayment";
import { Loading } from "../../components/Loading";
import { useNavigate } from "react-router-dom";
import { successfulCheckoutCart } from "../../store/cart/cartSuccess";

export function Checkout() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const data = useSelector((state) => state.cartSlice.data);

  const totalCart = data.reduce((acc, item) => {
    return acc + item.price * item.quantity;
  }, 0);

  const [fullName, setFullName] = useState("");
  const [telephone, setTelephone] = useState("(__) ____-____");
  const [email, setEmail] = useState("");
  const [cpf, setCpf] = useState("___.___.___-__");
  const [location, setLocation] = useState("Selecione");
  const [city, setCity] = useState("Selecione");
  const [address, setAddress] = useState("");
  const [number, setNumber] = useState("");
  const [cep, setCep] = useState("_____-___");
  const [complement, setComplement] = useState("");
  const [cpfStatus, setCpfStatus] = useState(false);
  const [cartNumber, setCartNumber] = useState("");
  const [cartName, setCartName] = useState("");
  const [cardDate, setCardDate] = useState("");
  const [cvv, setCvv] = useState("");
  const [orderPrice, setOrderPrice] = useState("");
  const [cardNumberStatus, setCardNumberStatus] = useState(false);
  const [showLoading, setShowLoading] = useState(false);

  function changeCpf() {
    if (cpf === "___.___.___-__") {
      setCpfStatus(true);
      setCpf("999.999.999-98");
    } else {
      setCpf("999.999.999-99");
      setCpfStatus(false);
    }
  }

  function changeCartNumber() {
    if (cartNumber === "") {
      setCardNumberStatus(true);
      setCartNumber("9999 9999 9999 9998");
    } else {
      setCartNumber("9999 9999 9999 9999");
      setCardNumberStatus(false);
    }
  }

  function handleClick(event) {
    event.preventDefault();
    dispatch(successfulCheckoutCart(true));

    setShowLoading(true);
    process.env.REACT_APP_DEMO_TYPE !== "full"
      ? setTimeout(() => navigate("/authenticate-app"), 2000)
      : setTimeout(() => navigate("/purchase-under-review"), 2000);
  }

  return (
    <CheckoutContainer>
      <FormContainer>
        <p className="titleHead">
          Ao preencher os dados abaixo você estará criando uma conta{" "}
          <strong>Happy Shop.</strong> <br />
          Utilize sua conta para futuras compras!
        </p>
        <CardGray>
          <h1 className="title">
            <span>1</span> Dados Cliente
          </h1>
          <div className="dataClient">
            <InputData
              width="17rem"
              value={fullName}
              onClick={() => setFullName("Josefina Kloser")}
              label="Nome completo"
            />
            <InputData
              width="10rem"
              value={telephone}
              onClick={() => setTelephone("(11) 99999-9999")}
              label="Telefone"
            />
            <InputData
              width="17rem"
              value={email}
              onClick={() => setEmail("josefinak@email.com.br")}
              label="E-mail"
            />
            <InputData
              width="10rem"
              value={cpf}
              onClick={changeCpf}
              label="CPF"
              errorCpf={cpfStatus === !false ? "CPF inválido" : ""}
            />
          </div>
        </CardGray>
        <CardGray>
          <h1 className="title">
            <span>2</span> Endereço de entrega
          </h1>
          <div className="dataAddress">
            <SelectData
              label="Estado"
              width="12rem"
              value={location}
              onClick={() => setLocation("São Paulo")}
            />

            <SelectData
              label="Cidade"
              width="15rem"
              value={city}
              onClick={() => setCity("Campinas")}
            />

            <InputData
              label="Endereço"
              width="22rem"
              value={address}
              onClick={() => setAddress("Rua das Amendoas")}
            />

            <InputData
              label="Nº"
              width="5rem"
              value={number}
              onClick={() => setNumber("001")}
            />

            <InputData
              label="CEP"
              width="7rem"
              value={cep}
              onClick={() => setCep("00000-000")}
            />

            <InputData
              label="Complemento"
              width="20rem"
              value={complement}
              onClick={() => setComplement("BL 1 AP 101")}
            />
          </div>
        </CardGray>
        <CardPayment>
          <div className="containerPayment">
            <h1 className="title">
              <span>3</span> Método de Pagamento
            </h1>
            <p>Selecione um método de pagamento:</p>
            <ul>
              <li>
                <input
                  type="radio"
                  id="creditCard"
                  name="payment"
                  value="creditCard"
                  defaultChecked={true}
                />
                <label htmlFor="creditCard">
                  <img src={CreditCard} alt="" /> Cartão de Crédito
                </label>
              </li>
              <li>
                <input
                  type="radio"
                  id="debitCard"
                  name="payment"
                  value="debitCard"
                  disabled={true}
                />
                <label htmlFor="debitCard">
                  <img src={Pix} alt="" />
                  PIX<span>(Código com validade de 30 minutos)</span>
                </label>
              </li>
              <li>
                <input
                  type="radio"
                  id="ticket"
                  name="payment"
                  value="ticket"
                  disabled={true}
                />
                <label htmlFor="ticket">
                  <img src={Ticket} alt="" />
                  Boleto<span>(Data de entrega confirmada após pagamento)</span>
                </label>
              </li>
            </ul>
            <div className="cartData">
              <h2>Adicione um cartão de crédito</h2>
              <div className="cartDataContent">
                <InputPayment
                  onClick={changeCartNumber}
                  label="Número do cartão"
                  value={cartNumber}
                  width="12rem"
                  errorCartNumber={
                    cardNumberStatus === !false
                      ? "Número do cartão inválido"
                      : ""
                  }
                />
                <InputPayment
                  onClick={() => setCartName("JOSEFINA KLOSER")}
                  label="Nome do cartão"
                  value={cartName}
                  width="12rem"
                />

                <InputPayment
                  onClick={() => setCardDate("03/2030")}
                  label="Data de validade"
                  value={cardDate}
                  width="8rem"
                />

                <InputPayment
                  onClick={() => setCvv("000")}
                  label="CVV"
                  value={cvv}
                  width="4rem"
                  info="O que é isso?"
                />
              </div>
              <div className="quantityPay">
                <label htmlFor="quantityPay">Parcelamento</label>
                <select>
                  <option
                    value={orderPrice}
                    onChange={(e) => setOrderPrice(e.target.value)}
                  >
                    {`1x ${totalCart.toLocaleString("pt-br", {
                      style: "currency",
                      currency: "BRL",
                    })} sem juros`}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <button onClick={handleClick}>Finalizar pedido</button>
        </CardPayment>
      </FormContainer>
      <SummaryContainer>
        <CardProductCheckout />
      </SummaryContainer>
      {showLoading && <Loading />}
    </CheckoutContainer>
  );
}
